export const BARE_METAL_NODES_FIELD_KEYS = {
  bmsNode: 'bmsNode',
  gpuName: 'gpuName',
  imageTags: 'imageTags',
} as const;

export const BARE_METAL_NODES_FIELD_KEY_LIST = [
  BARE_METAL_NODES_FIELD_KEYS.bmsNode,
  BARE_METAL_NODES_FIELD_KEYS.gpuName,
  BARE_METAL_NODES_FIELD_KEYS.imageTags,
] as const;

export const BARE_METAL_NODES_OPTION_META_KEYS = {
  node: 'node',
};
